const createRandomColorViaHSL = () => {
    const hue = Math.floor(Math.random() * 360),
          saturation = Math.floor((Math.random() * 70) + 50),
          lightness = Math.floor(Math.random() * 50);

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

export default createRandomColorViaHSL;